module.exports = __webpack_public_path__ + "media/images/logo-6765571fb4dff0607edf282f680341f4.png";